(() => {
    window.ShopifyUtils = {
        Storefront: {
            url: 'https://blupura.myshopify.com/api/2025-07/graphql.json',
            publicKey: 'bb89b080a5ff6d518969c09b28562623',
            get headers() {
                return {
                    'Content-Type': 'application/json',
                    'X-Shopify-Storefront-Access-Token': this.publicKey,
                };
            },
            async executeQuery(query, variables) {
                const res = await fetch(this.url, {
                    method: 'POST',
                    headers: this.headers,
                    body: JSON.stringify({ query, variables }),
                });

                const json = await res.json();
                if (json.errors) {
                    throw new Error(json.errors.map((e) => e.message).join('\n'));
                }

                return json;
            },
        },
        Cookie: {
            get(name) {
                const value = `; ${document.cookie}`;
                const parts = value.split(`; ${name}=`);
                if (parts.length === 2) return parts.pop().split(';').shift();
                return null;
            },
            getByPrefix(prefix) {
                const cookies = document.cookie.split(';').map((c) => c.trim());

                for (const cookie of cookies) {
                    if (cookie.startsWith(prefix)) {
                        const [name, value] = cookie.split('=');
                        return decodeURIComponent(value);
                    }
                }
                return null;
            },
        },
    };
})();
